import { AlertTriangle, User } from "lucide-react";
import { useState } from "react";
import Button from "./elements/Button";
import Input from "./elements/Input";

const NomineeLoginStep02 = ({ accounts, next, onBack }) => {
  const [selectedAccountId, setSelectedAccountId] = useState('');
  const [error, setError] = useState('');

  const handleAccountChanged = e => {
    setSelectedAccountId(e.target.value);
    setError('');
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (selectedAccountId) {
      next(selectedAccountId);
      setError('');
    } else {
      setError("Please select an account to proceed.");
    }
  };

  return (
    <div className="space-y-4 font-sans">
      <h2 className="text-2xl font-bold text-primary-dark text-center flex items-center justify-center font-sans">
        <User className="mr-3 text-accent-main" />
        Account Selection
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4 font-sans">
        <div>
          <Input
            label="Select Account"
            type="select"
            value={selectedAccountId}
            onChange={handleAccountChanged}
          >
            <option value="">Choose an account</option>
            {accounts.map(acc => (
              <option key={acc.id} value={acc.id}>{acc.email}</option>
            ))}
          </Input>
        </div>
        {error && (
          <div className="flex items-center p-3 text-red-700 bg-red-100 rounded-lg">
            <AlertTriangle className="w-5 h-5 mr-2" />
            <span className="text-sm">{error}</span>
          </div>
        )}
        <div className="text-center text-sm flex flex-col gap-2 font-sans">
          <Button type="submit" className="ml-auto">
            Next
          </Button>
        </div>
      </form>
      <div className="text-center text-sm flex flex-col gap-2 font-sans">
        <Button type="anchor" onClick={onBack}>
          Back to login
        </Button>
      </div>
    </div>
  );
};

export default NomineeLoginStep02;